import Typography from '@eduzz/houston-ui/Typography';
import { ButtonBase } from '@material-ui/core';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { EProductType } from 'v2/interfaces/product';

import styles from './styles';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  product: IProduct;
  classes?: any;
}

enum MethodIds {
  FILES = 5,
  NUTROR = 24,
}

const Deliveries = ({ product }: IProps) => {
  const deliveries = product.deliveries || [];

  const deliveryNames = useMemo(() => {
    const names = deliveries.map((item: any) => {
      if (item.method_id == MethodIds.FILES) {
        return 'Arquivos';
      }

      if (item.method_id == MethodIds.NUTROR) {
        return 'Nutror';
      }

      return 'Outros';
    });

    return Array.from(new Set(names));
  }, [deliveries]);

  return (
    <div style={{ color: '#37474F', fontWeight: 'bold' }}>
      Entrega:{' '}
      {product.type === EProductType.DIGITAL &&
        deliveryNames.map((item: string, index: number) => {
          const isLastItem = index + 1 === deliveryNames.length;
          return <span key={`item-${index}`}>{`${item}${!isLastItem ? ', ' : ''}`}</span>;
        })}
      {product.type === EProductType.PHYSICAL && 'Física'}
    </div>
  );
};

const Delivery = ({ product, classes }: IProps) => {
  return (
    <>
      <div>
        <Deliveries product={product} />
        <Typography size='xs' weight='semibold' className='share-link-title'>
          Agora que seu produto está pronto você pode habilitar recursos avançados
        </Typography>
      </div>
      <div>
        <Link to={`/producer/product/editproduct/${product.id}/sales`} className='share-link-button'>
          <ButtonBase classes={{ root: classes.buttonBase }} id='new-product-edit'>
            <span>Configurações avançadas</span>
          </ButtonBase>
        </Link>
      </div>
    </>
  );
};

export default styles(Delivery);
